<template>
    <div>
        <div class="py-2" v-if="$vuetify.breakpoint.xsOnly">
            <v-range-slider v-model="currentRange" @end="onRangeSliderChange" :min="min" :max="max" hide-details />
        </div>
        <div class="d-flex align-center justify-center">
            <div class="text-field pa-1">
                <v-text-field
                    dense
                    type="number"
                    :key="currentRange[0]"
                    :value="currentRange[0]"
                    @change="onChangeMin"
                    :suffix="unitSymbol"
                    outlined
                    hide-details
                />
            </div>
            <div class="grow d-flex justify-center" v-if="$vuetify.breakpoint.xsOnly">-</div>
            <div class="grow" v-else>
                <v-range-slider
                    v-model="currentRange"
                    @end="onRangeSliderChange"
                    :min="Math.floor(min)"
                    :max="Math.ceil(max)"
                    hide-details
                />
            </div>
            <div class="text-field pa-1">
                <v-text-field
                    dense
                    type="number"
                    :key="currentRange[1]"
                    :value="currentRange[1]"
                    @change="onChangeMax"
                    :suffix="unitSymbol"
                    outlined
                    hide-details
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Vue } from 'vue-property-decorator';
import { answerType, RangeValues } from '../definitions';
import { PropType } from 'vue';
export default Vue.extend({
    name: 'ShoppingGuideRangeSlider',
    props: {
        unitSymbol: {
            type: String,
            required: false,
            default: '',
        },
        min: {
            type: Number,
            required: false,
            default: 0,
        },
        max: {
            type: Number,
            required: false,
            default: 100,
        },
        currentRangeValues: {
            type: Object as PropType<RangeValues | null>,
            required: true,
        },
    },
    methods: {
        onRangeSliderChange([min, max]: [min: number, max: number]): void {
            this.currentRange = [min, max];
            this.$emit('changeValue', { min, max });
        },
        onChangeMin(newMin: number): void {
            const min = newMin >= this.min ? newMin : this.min;
            this.currentRange = [min, this.currentRange[1]];
            this.$emit('changeValue', { min, max: this.currentRange[1] });
        },
        onChangeMax(newMax: number): void {
            const max = newMax <= this.max ? newMax : this.max;
            this.currentRange = [this.currentRange[0], max];
            this.$emit('changeValue', { min: this.currentRange[0], max });
        },
    },
    watch: {
        currentRangeValues(rangeValue: RangeValues | null) {
            this.currentRange = [Math.floor(rangeValue?.min || this.min), Math.ceil(rangeValue?.max || this.max)];
        },
    },
    data() {
        return {
            currentRange: [
                Math.floor(this.currentRangeValues?.min || this.min),
                Math.ceil(this.currentRangeValues?.max || this.max),
            ] as number[],
            answerType,
        };
    },
});
</script>

<style scoped lang="scss">
.text-field {
    min-width: 80px;
    max-width: 120px;
}
.v-text-field::v-deep {
    input {
        // Resets default styling from Shopware 5
        box-shadow: unset;
    }
}
</style>
